import script from "./CardActionItems.vue?vue&type=script&setup=true&lang=js"
export * from "./CardActionItems.vue?vue&type=script&setup=true&lang=js"

import "./CardActionItems.vue?vue&type=style&index=0&id=47bdc15f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47bdc15f"]])

export default __exports__